import service from '../api/templateAssign.service';
//constants
const data = {
    assignation: null,
    createAssign: '',
    errorAssign: '',
}
//types
const ASSIGN_ITEM = 'ASSIGN_ITEM'
const ASSIGN_UPDATE = 'ASSIGN_UPDATE'
const ASSIGN_ERROR = 'ASSIGN_ERROR'

export default function templateAssignationReducer(state = data, action) {
    switch (action.type) {
        case ASSIGN_ITEM:
            return { ...state, assignation: action.payload };
        case ASSIGN_UPDATE:
            return { ...state, createAssign: action.payload };
        case ASSIGN_ERROR:
            return { ...state, errorAssign: action.payload };
        default:
            return { ...state };
    }
}

export const getAssignation = (entity, username) => async (dispatch) => {
    const response = await service.getAssignation(entity, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.code !== undefined) {
        dispatch({
            type: ASSIGN_ERROR,
            payload: response
        });
        dispatch({
            type: ASSIGN_ITEM,
            payload: null
        });

    } else {
        dispatch({
            type: ASSIGN_ERROR,
            payload: ''
        });
        dispatch({
            type: ASSIGN_ITEM,
            payload: response
        });
    }
}


export const create = (assignation, username) => async (dispatch) => {
    const response = await service.add(assignation, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.error !== undefined) {
        dispatch({
            type: ASSIGN_ERROR,
            payload: response
        });
        dispatch({
            type: ASSIGN_UPDATE,
            payload: ''
        });
    } else {
        dispatch({
            type: ASSIGN_ERROR,
            payload: ''
        });
        dispatch({
            type: ASSIGN_UPDATE,
            payload: response
        });
    }
}

export const update= (assignation, username) => async (dispatch) => {
    const response = await service.update(assignation, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data
    });

    if (response.error !== undefined) {
        dispatch({
            type: ASSIGN_ERROR,
            payload: response
        });
        dispatch({
            type: ASSIGN_UPDATE,
            payload: ''
        });
    } else {
        dispatch({
            type: ASSIGN_ERROR,
            payload: ''
        });
        dispatch({
            type: ASSIGN_UPDATE,
            payload: response
        });
    }
}